export const getData = (el, selector) =>
  Array.from(el.querySelector(`${selector}`).children).map(
    dataEntry => dataEntry.dataset,
  );

export const getDataSet = selector => document.querySelector(selector).dataset;
